import { SchemaModel, StringType } from 'rsuite'
import { subvalidators } from '../../../shared/passwordValidators'
import { debounce } from 'app/lib/utils'
import { isUsernameAvailable } from 'app/lib/user'

const debouncedIsUsernameAvailable = debounce(isUsernameAvailable, 300)

export function getSchemaModel(
  requirePasswordConfirmation = false,
  isEditMode = false,
) {
  const baseModelDef = {
    name: StringType()
      .isRequired('Name is required.')
      .minLength(2, 'Name must be at least 2 characters.')
      .maxLength(50, 'Name must be at most 50 characters.'),
    username: StringType()
      .minLength(6, 'Username must be at least 6 characters.')
      .maxLength(30, 'Username must be at most 30 characters.')
      .addAsyncRule(debouncedIsUsernameAvailable, 'Username is already taken.')
      .isRequired('Username is required.'),
    email: StringType()
      .isEmail('Valid email address is required.')
      .isRequired('Email is required.'),
    password: StringType().addRule(
      (value) =>
        !value ||
        Object.values(subvalidators).every((validator) => validator(value)),
      'Password requirements not met',
    ),
    phone: StringType().pattern(
      /^\(\d{3}\) \d{3}-\d{4}$/,
      'Phone number must be in the format (123) 456-7890.',
    ),
  }

  const requireConfirmationModelDef = {
    passwordConfirmation: StringType()
      .isRequired('Please confirm your password.')
      .addRule(
        (value, data) => value === data.password,
        'Passwords do not match.',
      ),
  }

  if (!isEditMode) {
    baseModelDef.password.isRequired('Password is required.')
  }

  const baseModel = SchemaModel(baseModelDef)
  const requireConfirmationModel = SchemaModel(requireConfirmationModelDef)

  const model = requirePasswordConfirmation
    ? SchemaModel.combine(baseModel, requireConfirmationModel)
    : baseModel

  return model
}
